import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional
} from '@angular/core';
import { ClientApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: []
})
export class ClientApiModule {
  public static forRoot(
    configurationFactory: () => ClientApiConfiguration
  ): ModuleWithProviders<ClientApiModule> {
    return {
      ngModule: ClientApiModule,
      providers: [
        { provide: ClientApiConfiguration, useFactory: configurationFactory }
      ]
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ClientApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ClientApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
